import { Box, Icon, IconTile, ListRow, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { SELECTION_TO_URL_BUILDER } from '../AssignmentStep';

type CreateNewPurposeButtonProps = {
  purposeType: string;
};

const createNewString = (type: string): string => {
  switch (type) {
    case 'EmergencyFund':
      return 'Create new emergency fund';
    case 'Retirement':
      return 'Create new retirement goal';
    case 'MajorPurchase':
      return 'Create new goal';
    default:
      return '';
  }
};

export const CreateNewPurposeButton: React.FC<CreateNewPurposeButtonProps> = ({ purposeType }) => {
  return (
    <SambaAutoLink
      to={SELECTION_TO_URL_BUILDER[purposeType].absolute()}
      variant="ghostSecondary"
      spacing="compact"
      css={{
        padding: 0,
        paddingInline: 0,
        borderStyle: 'solid',
        borderWidth: 'thin',
        borderColor: 'border.weak',
        borderRadius: 'medium',
      }}
    >
      <ListRow css={{ w: '100%' }}>
        <ListRow.LeadingAsset>
          <Box css={{ w: 'size.450', h: 'size.450' }}>
            <IconTile name="Plus" css={{ bg: 'background.neutral' }} />
          </Box>
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Text>{createNewString(purposeType)}</Text>
        </ListRow.LeadingContent>
        <ListRow.TrailingAsset>
          <Icon name="CaretRight" size="small" />
        </ListRow.TrailingAsset>
      </ListRow>
    </SambaAutoLink>
  );
};
